import styled, { css } from "styled-components";

import {
  fadeInAnimation,
  fadeUpAnimation,
} from "@sellernote/shipda-kr/src/components/landing/index.styles";
import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const containerWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLOR.wh};
`;

const container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 0;

  ${mobile(css`
    width: 100%;
    padding: 48px 16px;
    height: auto;
  `)};

  ${fadeUpAnimation};
  ${fadeInAnimation};

  > h3 {
    ${setFontStyle("Head4")};
    margin-bottom: 24px;
    animation-delay: 0.1s;

    ${mobile(css`
      ${setFontStyle("Head6")};
      margin-bottom: 32px;
    `)};
  }

  /** 애니메이션과 마진 추가를 위해 custom style 사용 */
  .custom-link-button {
    animation-delay: 0.85s;
    margin-top: 40px;

    ${mobile(css`
      margin-top: 32px;
      animation-delay: 1.45s;
    `)};
  }
`;

const logoImageContainer = styled.div`
  width: 1126px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${mobile(css`
    width: 100%;
    padding: 16px;
    margin-bottom: 32px;
  `)};

  .logo-image-1 {
    animation-delay: 0.5s;
  }

  .logo-image-2 {
    animation-delay: 0.8s;
  }

  .logo-image-3 {
    animation-delay: 1.1s;
  }

  .logo-image-4 {
    animation-delay: 1.4s;
  }
`;

const imageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default {
  containerWrapper,
  container,
  logoImageContainer,
  imageWrapper,
};
